var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-view-tab"},[_c('router-link',{staticClass:"tab",attrs:{"to":_vm.to,"tag":"div","exact":_vm.exact}},[_c('a',[_c('span',{staticClass:"label",domProps:{"textContent":_vm._s(_vm.label)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }